// Copyright 2016 Sorama B.V.

import { Loader } from "aurelia-loader";
declare const System: unknown;
declare const Origin: unknown;

export class LoaderExtensions {
    /**
     * Checks if a given moduleId exists.
     * @param loader The Loader to use to check for module existance.
     * @param moduleId The id (path) of the module to check for exsitance.
     * @return A promise resolving with true if the module exists, with false if it does not exist.
     */
    public static exists(loader: Loader, moduleId: string): Promise<boolean> {
        return loader
            .loadTemplate(moduleId)
            .then(() => true)
            .catch(() => false);
    }
}
